
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35137',
  depVersions: {
  "documents-public-ui": "static-1.35137",
  "atom": "static-1.5340",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2751",
  "client-types": "static-1.493",
  "cssUtils": "static-1.873",
  "customer-data-filters-ui": "static-1.40784",
  "customer-data-objects": "static-1.7940",
  "customer-data-property-utils": "static-1.8352",
  "documents-lib": "static-1.35142",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.361",
  "FormsCommonComponents": "static-1.86478",
  "FormUrlGenerator": "static-2.4981",
  "foundations-theming-specialty": "static-1.2434",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5850",
  "hs-test-utils": "static-1.8280",
  "hub-http": "static-1.6468",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12045",
  "HubStyleTokens": "static-2.11738",
  "I18n": "static-7.1664",
  "icons": "static-2.675",
  "jasmine-immutable": "static-1.3276",
  "jasmine-runner": "static-1.6703",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7407",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3152",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5652",
  "quartz": "static-1.7384",
  "react": "static-7.191",
  "react-dlb": "static-1.85",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1.16966",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5522",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8434",
  "reference-resolvers-lite": "static-1.8355",
  "reporting-data": "static-1.68628",
  "reporting-reports": "static-1.68306",
  "reporting-snowflake": "static-1.57246",
  "reporting-testing-lib": "static-1.10561",
  "reporting-visualizations": "static-1.60704",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9205",
  "sanitize": "static-1.4730",
  "sanitize-text": "static-1-fix-mxss-decode-tags-foreign-content.3",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2002",
  "signup-constants": "static-1.19522",
  "signup-ui-url-generator": "static-2.8314",
  "StyleGuideUI": "static-3.496",
  "superstore": "static-1.5010",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5009",
  "ui-addon-form-validation": "static-1.11240",
  "ui-asset-management-lib": "static-1.11350",
  "ui-images": "static-2.1231",
  "UIComponents": "static-3.8684",
  "usage-tracker": "static-1.7611",
  "usage-tracker-container": "static-1.7601",
  "usage-tracker-core": "static-1.7461",
  "viral-links-lib": "static-1.7329",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9911",
  "foundations-components": "static-1.8403",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1162",
  "quartz-core": "static-1.6603",
  "quick-fetch": "static-1.4100",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4918",
  "ui-addon-i18n": "static-1.11397",
  "ui-addon-upgrades": "static-9.18326",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3586",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3661",
  "quartz-webpack": "static-1.3608",
  "foundations-assets": "static-1.5135",
  "foundations-theming": "static-1.4718",
  "hub-http-janus": "static-1.870",
  "hub-http-shared-msw-handlers": "static-1.10540",
  "hubspotter-http": "static-1.4830",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7503",
  "crm-message-bus": "static-1.43660",
  "customer-data-filters-ui-msw-helpers": "static-1.23219",
  "customer-data-objects-ui-components": "static-1.13284",
  "customer-data-reference-ui-components": "static-1.13435",
  "customer-data-ui-utilities": "static-1.10082",
  "events-data-lib": "static-1.495",
  "framework-builder-read-service-client": "static-1.4189",
  "hs-resources": "static-1.445",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4025",
  "multi-account-reference-resolvers": "static-1.1251",
  "onboarding-scopes": "static-1.6709",
  "onboarding-tours": "static-1.17051",
  "pulse": "static-1.880",
  "reporting-datasets-permissions-lib": "static-1.14383",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2496",
  "trellis-components": "static-1.2515",
  "trellis-theming": "static-1.1220",
  "ui-addon-teams": "static-1.21861",
  "quartz-auth": "static-1.1059",
  "ui-business-units-lib": "static-1.9338",
  "usage-tracker-session-replay": "static-1.5297",
  "ai-components-ui-library": "static-1.9614",
  "ContentUtils": "static-1.69063",
  "customer-data-properties": "static-1.52456",
  "forms-ai-lib": "static-1.4702",
  "forms-utils-lib": "static-1.13030",
  "foundations-components-test-utils": "static-1.5886",
  "react-dnd-compat": "static-1.4870",
  "react-tinymce": "static-1.55892",
  "tinymce-config": "static-2.55018",
  "ui-gdpr-components": "static-1.10610",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3703",
  "HeadJS": "static-2.790",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3391",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.261",
  "ui-fonts": "static-1.1000",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4571",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1049",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1796",
  "external-options-client-types": "static-1.4307",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7147",
  "quartz-i18n": "static-1.1059",
  "frontend-preferences-client": "static-1.8181",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3953",
  "reporting-client-types": "static-1.2652",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26090",
  "hubspot-apollo-client": "static-1.5133",
  "foundations-components-legacy": "static-1.1428",
  "quartz-routing": "static-1.814",
  "hs-story-utils": "static-1.9681",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.489",
  "seat-types-lib": "static-1.643",
  "timezone-utils": "static-2.5502",
  "react-create-root-preference": "static-1.63",
  "bend-plugin-foundations-components": "static-1.4672",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.21",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.396",
  "quartz-test": "static-1.1059",
  "quartz-tracking": "static-1.763",
  "bend-plugin-chirp-manifest": "static-1.328",
  "chirp-fetch": "static-1.2147",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6291",
  "salesImages": "static-1.530",
  "ts-schema": "static-1.4262",
  "bender-build-tools": "static-1.3382",
  "bend-plugin-foundations-theming": "static-1.3201",
  "restore-request-side-panel-lib": "static-1.1574",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4911",
  "conditional-properties-service-client": "static-1.3982",
  "crm-pipelines-api-client-types": "static-1.4316",
  "event-emitter": "static-1.1207",
  "fdsr-migration-layer": "static-1.266",
  "multi-currency-client-types": "static-1.3877",
  "getting-started-shared-tasks": "static-1.19131",
  "growth-data-modal": "static-1.5829",
  "growth-onboarding-confetti": "static-1.3316",
  "growth-onboarding-next-action-utils": "static-1.2610",
  "navigation-components": "static-1.18729",
  "onboarding-tours-client": "static-1.5265",
  "onboarding-tours-utils": "static-1.1117",
  "ui-shepherd-react": "static-3.10518",
  "ui-shepherd-tracker": "static-1.7899",
  "ui-universal-auth": "static-1.9307",
  "user-context": "static-1.5369",
  "bend-plugin-pulse": "static-1.383",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10538",
  "magpie-lib": "static-1.5724",
  "navigation-messaging": "static-1.8056",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22677",
  "copilot-toolkit": "static-1.11762",
  "cms-field-types": "static-1.5070",
  "content-icons-ui": "static-1.2319",
  "integrations-lib": "static-1.16942",
  "calling-global-api": "static-1.65402",
  "calling-internal-common": "static-1.31572",
  "calling-lifecycle-internal": "static-1.66784",
  "calling-lifecycle-messages": "static-1.59078",
  "commerce-products-lib": "static-1.10426",
  "crm-index-visualization-core": "static-1.4484",
  "crm-links": "static-1.6579",
  "customer-data-properties-shared-msw-handlers": "static-1.9867",
  "file-manager-components": "static-1.24378",
  "formula-editor": "static-1.14685",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4392",
  "meetings-icalendar-utils-lib": "static-1.890",
  "object-builder-ui-client": "static-1.49558",
  "pipeline-validation-client-types": "static-1.4150",
  "property-value-citations": "static-1.3070",
  "smart-data-capture-core": "static-1.43",
  "smart-property-lib": "static-1.8187",
  "tiered-pricing": "static-1.1883",
  "trial-components-library": "static-1.14035",
  "topics-actions-lib": "static-1.419",
  "ui-addon-iframeable": "static-1.9330",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20244",
  "tinymce-themes": "static-1.56988",
  "data-token-picker": "static-1.16825",
  "hub-http-contrib": "static-1.3293",
  "interframe": "static-3.5010",
  "tinymce-data": "static-1.41103",
  "tinymce-plugins": "static-1.58132",
  "ui-addon-sales-email": "static-1.5469",
  "framework-data-schema-quick-fetch": "static-1.7052",
  "ui-addon-opt": "static-4.8618",
  "hubspot-apollo-cache": "static-1.592",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6294",
  "onboarding-data-sync-lib": "static-1.2426",
  "growth-onboarding-next-action-components": "static-1.2638",
  "user-context-client": "static-1.4763",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5184",
  "nest": "static-1.490",
  "reactive-lib": "static-1.976",
  "simple-logging-lib": "static-1.3305",
  "unified-auth-core-lib": "static-1.1103",
  "getting-started-shared-tasks-store": "static-1.18249",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1591",
  "integrations-error-boundary-lib": "static-1.14357",
  "integrations-tracking-lib": "static-1.5863",
  "native-integrations-shared-strings": "static-1.8032",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10620",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.821",
  "calling-error-reporting": "static-1.31579",
  "shared-worker-versioning": "static-1.11295",
  "calling-usage-tracker": "static-1.6793",
  "voice-sms-access-library": "static-1.1927",
  "customer-data-tracking": "static-1.7136",
  "commerce-permissions": "static-1.1031",
  "products-iframe-lib": "static-1.8511",
  "products-ui-components-shared-msw-handlers": "static-1.10922",
  "crm-index-associations-lib": "static-1.6697",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10623",
  "sales-views-client-types": "static-1.4512",
  "location-customization-utils-lib": "static-1.10005",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4406",
  "video-components-external": "static-1.12077",
  "video-data-lib": "static-1.35735",
  "bark-lib": "static-1.16761",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6145",
  "react-codemirror": "static-1.10894",
  "data-agent-kit": "static-1.583",
  "feedback-loader": "static-1.29744",
  "fsm": "static-1.3994",
  "policy-lib": "static-1.7050",
  "react-colorpicker": "static-2.10463",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10686",
  "embedded-academy-lib": "static-1.15393",
  "hubs-service-types": "static-1.1513",
  "FileManagerLib": "static-1.40018",
  "NamespacedHubStyle": "static-2.9230",
  "FileManagerCore": "static-1.39877",
  "content-assistance-lib": "static-1.8141",
  "layout-dnd-components": "static-1.12900",
  "layout-dnd-utils": "static-1.11875",
  "ui-addon-emoji-picker": "static-1.10139",
  "ui-brand-identity-lib": "static-1.16249",
  "InboxConnectUtils": "static-4.15473",
  "meetings-connect-utils-lib": "static-1.7864",
  "breeze-engine-chat-components": "static-1.569",
  "breeze-engine-core": "static-1.869",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3262",
  "adobe-sign-auth-lib": "static-1.368",
  "ads-unified-auth-lib": "static-1.1105",
  "google-sheets-integration-lib": "static-1.945",
  "microsoft-drive-auth-lib": "static-1.38",
  "surveymonkey-integration-lib": "static-1.389",
  "slack-ui-library": "static-1.10653",
  "calling-orchestration-schema": "static-1.36704",
  "crm-record-cards-service-types": "static-1.3759",
  "content-media-composition-data-lib": "static-1.13136",
  "content-media-compositions": "static-2.17143",
  "media-bridge-lib": "static-1.19346",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16282",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4765",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14853",
  "audio-components": "static-1.6282",
  "FileManagerImages": "static-1.37529",
  "video-components": "static-1.14079",
  "breeze-artifacts-sdk": "static-1.208",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4787",
  "video-embed": "static-1.36569",
  "ui-addon-video-player": "static-1.8958",
  "ui-coaching-tips": "static-1.29230",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10200",
  "academy-service-client": "static-1.3943",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4659",
  "trellis-ecosystem": "static-1.7570",
  "ui-addon-react-router-dom": "static-1.9791",
  "wootric-nps": "static-1.7167",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4415",
  "growth-onboarding-feedback-components": "static-1.6839",
  "advanced-menus-core": "static-1.15517",
  "advanced-menus-lib": "static-1.12397",
  "ExportDialog": "static-6.10633",
  "ui-memberships-settings-lib": "static-1.34756",
  "marketplace-ui-apps-core": "static-1.19152",
  "marketplace-ui-common": "static-1.20620",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15516",
  "simple-menus-lib": "static-1.17033",
  "developer-experience-shared-components": "static-1.10755",
  "immutable-less": "static-1.4905",
  "marketplace-ui-client-types": "static-1.18027",
  "ui-addon-integrations-directory-panel": "static-2.8281",
  "ui-extensibility-client-types": "static-1.4175",
  "ai-settings-ui-library": "static-1.8265",
  "nav-meta": "static-1.30366",
  "ui-product-approvals-common": "static-1.897",
  "apps-service-types": "static-1.3996",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3451"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35137",
  "atom": "/atom/static-1.5340",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2751",
  "client-types": "/client-types/static-1.493",
  "cssUtils": "/cssUtils/static-1.873",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40784",
  "customer-data-objects": "/customer-data-objects/static-1.7940",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8352",
  "documents-lib": "/documents-lib/static-1.35142",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.361",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4981",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2434",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5850",
  "hs-test-utils": "/hs-test-utils/static-1.8280",
  "hub-http": "/hub-http/static-1.6468",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12045",
  "HubStyleTokens": "/HubStyleTokens/static-2.11738",
  "I18n": "/I18n/static-7.1664",
  "icons": "/icons/static-2.675",
  "jasmine-immutable": "/jasmine-immutable/static-1.3276",
  "jasmine-runner": "/jasmine-runner/static-1.6703",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7407",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3152",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5652",
  "quartz": "/quartz/static-1.7384",
  "react": "/react/static-7.191",
  "react-dlb": "/react-dlb/static-1.85",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1.16966",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5522",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8434",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8355",
  "reporting-data": "/reporting-data/static-1.68628",
  "reporting-reports": "/reporting-reports/static-1.68306",
  "reporting-snowflake": "/reporting-snowflake/static-1.57246",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10561",
  "reporting-visualizations": "/reporting-visualizations/static-1.60704",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9205",
  "sanitize": "/sanitize/static-1.4730",
  "sanitize-text": "/sanitize-text/static-1-fix-mxss-decode-tags-foreign-content.3",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2002",
  "signup-constants": "/signup-constants/static-1.19522",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8314",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "superstore": "/superstore/static-1.5010",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5009",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11240",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11350",
  "ui-images": "/ui-images/static-2.1231",
  "UIComponents": "/UIComponents/static-3.8684",
  "usage-tracker": "/usage-tracker/static-1.7611",
  "usage-tracker-container": "/usage-tracker-container/static-1.7601",
  "usage-tracker-core": "/usage-tracker-core/static-1.7461",
  "viral-links-lib": "/viral-links-lib/static-1.7329",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9911",
  "foundations-components": "/foundations-components/static-1.8403",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1162",
  "quartz-core": "/quartz-core/static-1.6603",
  "quick-fetch": "/quick-fetch/static-1.4100",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4918",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11397",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18326",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3586",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3661",
  "quartz-webpack": "/quartz-webpack/static-1.3608",
  "foundations-assets": "/foundations-assets/static-1.5135",
  "foundations-theming": "/foundations-theming/static-1.4718",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10540",
  "hubspotter-http": "/hubspotter-http/static-1.4830",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7503",
  "crm-message-bus": "/crm-message-bus/static-1.43660",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23219",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13284",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13435",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10082",
  "events-data-lib": "/events-data-lib/static-1.495",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4189",
  "hs-resources": "/hs-resources/static-1.445",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4025",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1251",
  "onboarding-scopes": "/onboarding-scopes/static-1.6709",
  "onboarding-tours": "/onboarding-tours/static-1.17051",
  "pulse": "/pulse/static-1.880",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14383",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2496",
  "trellis-components": "/trellis-components/static-1.2515",
  "trellis-theming": "/trellis-theming/static-1.1220",
  "ui-addon-teams": "/ui-addon-teams/static-1.21861",
  "quartz-auth": "/quartz-auth/static-1.1059",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9338",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5297",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9614",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-properties": "/customer-data-properties/static-1.52456",
  "forms-ai-lib": "/forms-ai-lib/static-1.4702",
  "forms-utils-lib": "/forms-utils-lib/static-1.13030",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5886",
  "react-dnd-compat": "/react-dnd-compat/static-1.4870",
  "react-tinymce": "/react-tinymce/static-1.55892",
  "tinymce-config": "/tinymce-config/static-2.55018",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10610",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3703",
  "HeadJS": "/HeadJS/static-2.790",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3391",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.261",
  "ui-fonts": "/ui-fonts/static-1.1000",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4571",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1049",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1796",
  "external-options-client-types": "/external-options-client-types/static-1.4307",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7147",
  "quartz-i18n": "/quartz-i18n/static-1.1059",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8181",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3953",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26090",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5133",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1428",
  "quartz-routing": "/quartz-routing/static-1.814",
  "hs-story-utils": "/hs-story-utils/static-1.9681",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.489",
  "seat-types-lib": "/seat-types-lib/static-1.643",
  "timezone-utils": "/timezone-utils/static-2.5502",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4672",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.21",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.396",
  "quartz-test": "/quartz-test/static-1.1059",
  "quartz-tracking": "/quartz-tracking/static-1.763",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.328",
  "chirp-fetch": "/chirp-fetch/static-1.2147",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6291",
  "salesImages": "/salesImages/static-1.530",
  "ts-schema": "/ts-schema/static-1.4262",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3201",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1574",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4911",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3982",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4316",
  "event-emitter": "/event-emitter/static-1.1207",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.266",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3877",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19131",
  "growth-data-modal": "/growth-data-modal/static-1.5829",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3316",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2610",
  "navigation-components": "/navigation-components/static-1.18729",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5265",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1117",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10518",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7899",
  "ui-universal-auth": "/ui-universal-auth/static-1.9307",
  "user-context": "/user-context/static-1.5369",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.383",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10538",
  "magpie-lib": "/magpie-lib/static-1.5724",
  "navigation-messaging": "/navigation-messaging/static-1.8056",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22677",
  "copilot-toolkit": "/copilot-toolkit/static-1.11762",
  "cms-field-types": "/cms-field-types/static-1.5070",
  "content-icons-ui": "/content-icons-ui/static-1.2319",
  "integrations-lib": "/integrations-lib/static-1.16942",
  "calling-global-api": "/calling-global-api/static-1.65402",
  "calling-internal-common": "/calling-internal-common/static-1.31572",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66784",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59078",
  "commerce-products-lib": "/commerce-products-lib/static-1.10426",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4484",
  "crm-links": "/crm-links/static-1.6579",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9867",
  "file-manager-components": "/file-manager-components/static-1.24378",
  "formula-editor": "/formula-editor/static-1.14685",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4392",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.890",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49558",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4150",
  "property-value-citations": "/property-value-citations/static-1.3070",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.43",
  "smart-property-lib": "/smart-property-lib/static-1.8187",
  "tiered-pricing": "/tiered-pricing/static-1.1883",
  "trial-components-library": "/trial-components-library/static-1.14035",
  "topics-actions-lib": "/topics-actions-lib/static-1.419",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9330",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20244",
  "tinymce-themes": "/tinymce-themes/static-1.56988",
  "data-token-picker": "/data-token-picker/static-1.16825",
  "hub-http-contrib": "/hub-http-contrib/static-1.3293",
  "interframe": "/interframe/static-3.5010",
  "tinymce-data": "/tinymce-data/static-1.41103",
  "tinymce-plugins": "/tinymce-plugins/static-1.58132",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5469",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7052",
  "ui-addon-opt": "/ui-addon-opt/static-4.8618",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.592",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6294",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2426",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2638",
  "user-context-client": "/user-context-client/static-1.4763",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5184",
  "nest": "/nest/static-1.490",
  "reactive-lib": "/reactive-lib/static-1.976",
  "simple-logging-lib": "/simple-logging-lib/static-1.3305",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1103",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18249",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1591",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14357",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5863",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8032",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10620",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.821",
  "calling-error-reporting": "/calling-error-reporting/static-1.31579",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11295",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6793",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1927",
  "customer-data-tracking": "/customer-data-tracking/static-1.7136",
  "commerce-permissions": "/commerce-permissions/static-1.1031",
  "products-iframe-lib": "/products-iframe-lib/static-1.8511",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10922",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6697",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10623",
  "sales-views-client-types": "/sales-views-client-types/static-1.4512",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10005",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4406",
  "video-components-external": "/video-components-external/static-1.12077",
  "video-data-lib": "/video-data-lib/static-1.35735",
  "bark-lib": "/bark-lib/static-1.16761",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6145",
  "react-codemirror": "/react-codemirror/static-1.10894",
  "data-agent-kit": "/data-agent-kit/static-1.583",
  "feedback-loader": "/feedback-loader/static-1.29744",
  "fsm": "/fsm/static-1.3994",
  "policy-lib": "/policy-lib/static-1.7050",
  "react-colorpicker": "/react-colorpicker/static-2.10463",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10686",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15393",
  "hubs-service-types": "/hubs-service-types/static-1.1513",
  "FileManagerLib": "/FileManagerLib/static-1.40018",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9230",
  "FileManagerCore": "/FileManagerCore/static-1.39877",
  "content-assistance-lib": "/content-assistance-lib/static-1.8141",
  "layout-dnd-components": "/layout-dnd-components/static-1.12900",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11875",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10139",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16249",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15473",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7864",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.569",
  "breeze-engine-core": "/breeze-engine-core/static-1.869",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3262",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.368",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1105",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.945",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.38",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.389",
  "slack-ui-library": "/slack-ui-library/static-1.10653",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36704",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13136",
  "content-media-compositions": "/content-media-compositions/static-2.17143",
  "media-bridge-lib": "/media-bridge-lib/static-1.19346",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16282",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4765",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14853",
  "audio-components": "/audio-components/static-1.6282",
  "FileManagerImages": "/FileManagerImages/static-1.37529",
  "video-components": "/video-components/static-1.14079",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.208",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4787",
  "video-embed": "/video-embed/static-1.36569",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8958",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29230",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10200",
  "academy-service-client": "/academy-service-client/static-1.3943",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4659",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7570",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9791",
  "wootric-nps": "/wootric-nps/static-1.7167",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4415",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6839",
  "advanced-menus-core": "/advanced-menus-core/static-1.15517",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12397",
  "ExportDialog": "/ExportDialog/static-6.10633",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34756",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19152",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20620",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15516",
  "simple-menus-lib": "/simple-menus-lib/static-1.17033",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10755",
  "immutable-less": "/immutable-less/static-1.4905",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18027",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8281",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4175",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8265",
  "nav-meta": "/nav-meta/static-1.30366",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.897",
  "apps-service-types": "/apps-service-types/static-1.3996",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3451"
}
};
